import type { ReactNode } from 'react'
import { createContext, useContext as useContextCore } from 'react'
import { ToastProvider } from '@ztechapps/webui.util'
import { ConfirmDialogProvider } from '@ztechapps/webui.modal'
import { ThemeContext, ColorModeEnum } from '@ztechapps/common.hook'
import { LayoutProvider, useLayoutContext, ThemeMode } from '../../context/LayoutContext'

export type AppContextType = {
  data?: any
}

const context = createContext<AppContextType>({} as AppContextType)
const CoreProvider = context.Provider

const ThemeBridge = ({ children }: { children: ReactNode }) => {
  const { state, toggleTheme } = useLayoutContext()
  const isDark = state.theme === ThemeMode.Dark
  const colorMode = isDark ? ColorModeEnum.dark : ColorModeEnum.light

  return (
    <ThemeContext.Provider
      value={{
        iconType: 'fa6i',
        routerType: 'react-router',
        colorMode: {
          colorMode,
          toggle: toggleTheme,
          enable: () => undefined,
          disable: () => undefined,
          isDark,
        },
      }}
    >
      {children}
    </ThemeContext.Provider>
  )
}

export const AppContextProvider = ({ children }: { children: ReactNode }) => {
  return (
    <LayoutProvider>
      <ThemeBridge>
        <CoreProvider value={{}}>
          <ToastProvider>
            <ConfirmDialogProvider>{children}</ConfirmDialogProvider>
          </ToastProvider>
        </CoreProvider>
      </ThemeBridge>
    </LayoutProvider>
  )
}

export const useAppContext = () => useContextCore(context)
